import { render, staticRenderFns } from "./ServicesTable.vue?vue&type=template&id=232fdb6a&scoped=true"
import script from "./ServicesTable.vue?vue&type=script&lang=ts"
export * from "./ServicesTable.vue?vue&type=script&lang=ts"
import style0 from "./ServicesTable.vue?vue&type=style&index=0&id=232fdb6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232fdb6a",
  null
  
)

export default component.exports